import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import api from '../api';
import Formulario from './Formulario';

const GenerarPDF = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const [formData, setFormData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        fetchFormulario();
    }, [id]);

    const fetchFormulario = async () => {
        try {
            const res = await api.get(`https://cna.clublostortugas.com/api/api.php?action=get_form&id=${id}`);
            if (res.data.success) {
                setFormData(res.data.data);
            }
        } catch (err) {
            setError("No se pudo cargar el formulario o no existe.");
        } finally {
            setLoading(false);
        }
    };

    if (loading) return <div className="text-center mt-5">Cargando PDF...</div>;
    if (error) return <div className="text-center mt-5 text-danger">{error}</div>;

    return (
        <div className="pdf-viewer pt-4 pb-5 bg-light" style={{ minHeight: '100vh' }}>
            <div className="container d-print-none mb-4 d-flex justify-content-between">
                <button className="btn btn-secondary" onClick={() => navigate('/dashboard')}>
                    &larr; Volver al Panel
                </button>
                <div className="alert alert-info py-2 mb-0">
                    Haz clic en el botón superior derecho del formulario para Imprimir o Guardar como PDF
                </div>
            </div>

            {/* Reutilizamos el Formulario pero en modo Solo Lectura, mostramos botón de imprimir */}
            {formData && <Formulario initialData={formData} readOnly={true} showPrintButton={true} />}
        </div>
    );
};

export default GenerarPDF;
